import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { taxInfoSchema } from './tax-info';
export const paymentDetailsResponseSchema = z
    .object({
    name: z.string().optional(),
    card: z
        .object({
        brand: z.string(),
        numberLast4: z.string(),
        expiryMonth: z.number(),
        expiryYear: z.number(),
    })
        .optional(),
    billingAddress: z
        .object({
        line1: z.string(),
        line2: z.string(),
        city: z.string(),
        country: z.string(),
        postalCode: z.string(),
        state: z.string(),
    })
        .optional(),
    taxInfo: taxInfoSchema.optional(),
})
    .optional()
    .default({});
export class PaymentDetailsResponseDto extends createZodDto(paymentDetailsResponseSchema) {
}
